import { useCallback } from 'react';
import { backendErrorMessage, useApiCall } from './apiHelpers';

export interface SendBatPersonalField {
  name: string;
  value: string;
}

export interface SendBatPayload {
  channel: 'EMAIL' | 'SMS';
  message: string;
  recipients: string[];
  name?: string;
  sender?: string;
  sendDate?: string;
  fields?: SendBatPersonalField[];
  object?: string;
  autocomplete?: boolean;
}

export type SendBatOutcome = { ok: true; message?: string } | { ok: false; message: string };

export const useSendBat = () => {
  const { authFetch, isReady, run, isLoading, error } = useApiCall(backendErrorMessage);

  const sendBat = useCallback(
    async (payload: SendBatPayload): Promise<SendBatOutcome> => {
      if (!isReady) return { ok: false, message: 'Session non prête, veuillez réessayer.' };
      const outcome = await run<{ message?: string } | null>(
        () => authFetch('/sendBat', { method: 'POST', body: JSON.stringify(payload) }),
        "Erreur lors de l'envoi du BAT",
      );
      return outcome.ok ? { ok: true, message: outcome.data?.message } : { ok: false, message: outcome.message };
    },
    [authFetch, isReady, run],
  );

  return { sendBat, loading: isLoading, error: error || null };
};
